export default __webpack_public_path__ + "static/media/vip.126a05ec.png";